import { render } from "./HereditaryCaseList.vue?vue&type=template&id=bf9340a4&scoped=true"
import script from "./HereditaryCaseList.vue?vue&type=script&lang=js"
export * from "./HereditaryCaseList.vue?vue&type=script&lang=js"

import "./HereditaryCaseList.vue?vue&type=style&index=0&id=bf9340a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9340a4"]])

export default __exports__